const topBg = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {


    ScrollTrigger.create({
      trigger: '#jsSecBgTrigger0',
      start: 'top center',
      endTrigger: "body",
      end: 'bottom top',
      toggleClass: { targets: "#jsMainImgBox", className: "none" },
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: '#jsSecBgTrigger0',
      start: 'top center',
      endTrigger: "body",
      end: 'bottom top',
      toggleClass: { targets: "#jsSecBg", className: "act" },
      // markers: true,
    });
    // ScrollTrigger.create({
    //   trigger: '#jsSecBgTrigger1',
    //   start: 'top center',
    //   endTrigger: "body",
    //   end: 'bottom top', 
    //   toggleClass: {targets: "#jsSecBg", className: "change1"},
    //   // markers: true,
    // });
    ScrollTrigger.create({
      trigger: '#jsSecBgTrigger2',
      start: '0% 150%',
      // endTrigger: "body",
      end: '100% -50%',
      toggleClass: { targets: "#jsSecBg", className: "change2" },
      // markers: true,
    });


  }
})();
export default topBg;